import { useEffect } from 'react';

const homeProductSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'Product',
    '@id': 'https://soldageo.com.br/produto/bt950',
    url: 'https://soldageo.com.br/produto/bt950',
    name: 'BT950 — Máquina de Solda Geomembrana Cunha Quente',
    description:
      'Máquina de solda geomembrana de cunha quente com 2100W, velocidade de 5–8 m/min e controle digital de temperatura de 0 a 500°C. Compatível com PEAD, PELBD e PVC de 500 a 3000 microns. Distribuidor oficial no Brasil com suporte técnico local.',
    image:
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/8462c72463ed032b769bac2491845c56.png',
    sku: 'BT950',
    mpn: 'BT950-2100W',
    brand: {
      '@id': 'https://soldageo.com.br/#organization',
    },
    model: 'BT950',
    category: 'Máquinas de Solda Geomembrana',
    material: 'PEAD, PELBD, PVC',
    countryOfOrigin: 'CN',
    additionalProperty: [
      { '@type': 'PropertyValue', name: 'Potência', value: '2100W / 220V' },
      { '@type': 'PropertyValue', name: 'Velocidade de Soldagem', value: '5–8 m/min' },
      { '@type': 'PropertyValue', name: 'Temperatura de Operação', value: '0–500°C' },
      { '@type': 'PropertyValue', name: 'Espessura de Geomembrana', value: '0,5–3,0 mm' },
      { '@type': 'PropertyValue', name: 'Largura de Solda', value: '40 mm' },
      { '@type': 'PropertyValue', name: 'Peso', value: '11 kg' },
      { '@type': 'PropertyValue', name: 'Garantia', value: '6 meses' },
    ],
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      priceCurrency: 'BRL',
      price: '0',
      url: 'https://wa.me/554891802091',
      description: 'Preço sob consulta — solicite orçamento via WhatsApp',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Product',
    '@id': 'https://soldageo.com.br/produto/ex3',
    url: 'https://soldageo.com.br/produto/ex3',
    name: 'Extrusora EX3 — Extrusora Manual para Geomembrana',
    description:
      'Extrusora manual para soldagem de geomembranas espessas. Produção de 3,5 kg/h, temperatura de até 700°C, compatível com fio PEAD de Ø 3,0–4,0 mm. Ideal para reparos, cantos e junções em PEAD, PELBD e PVC. Distribuidor oficial no Brasil.',
    image:
      'https://public.readdy.ai/ai/img_res/31b3cc2e-3832-4fee-a11b-ad416dc50f78.png',
    sku: 'EX3',
    brand: {
      '@id': 'https://soldageo.com.br/#organization',
    },
    model: 'EX3',
    category: 'Extrusoras para Geomembrana',
    additionalProperty: [
      { '@type': 'PropertyValue', name: 'Potência', value: '3400W' },
      { '@type': 'PropertyValue', name: 'Produção', value: '3,5 kg/h' },
      { '@type': 'PropertyValue', name: 'Temperatura Máxima', value: '700°C' },
      { '@type': 'PropertyValue', name: 'Diâmetro do Fio', value: 'Ø 3,0–4,0 mm' },
      { '@type': 'PropertyValue', name: 'Tipo de Solda', value: 'Extrusão' },
    ],
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      priceCurrency: 'BRL',
      price: '0',
      url: 'https://wa.me/554891802091',
      description: 'Preço sob consulta — solicite orçamento via WhatsApp',
    },
  },
];

export default function HomeSeoSchema() {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];

    homeProductSchemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `home-product-schema-${index}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    return () => {
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return null;
}